import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, ref, watch } from "vue";
  import DropDown from "@/components/ui/dropdown/DropDown.vue";
  import EstateMap from "@/v2/components/EstateMap.vue";
  import {
    stagesStatuses,
    StatusFiltersLabels,
    StatusFiltersValues,
  } from "@/constants/statusFilters";
  import router from "@/router";
  import { useStore } from "vuex";
  import { StageInterface } from "@/types/StageInterface";
  import plural from "@/features/plural";
  import { getStageStatusClass } from "@/helpers/status";
  import { copyToClipboard } from "@/helpers/copyToClipboard";
  import { EstateInterface } from "@/types/EstateInterface";
  import {
    getEstateMapPath,
    usesInteractiveMasterplan,
  } from "@/helpers/estateMapRoute";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'StagesView',
  setup(__props, { expose: __expose }) {
  __expose();

  const store = useStore();
  const viewType = ref<"list" | "map">("list");
  const filters = stagesStatuses;
  const activeFilter = ref(stagesStatuses[0]);
  const stages = ref<StageInterface[]>([]);
  const estateId = computed(() => store.state.user.selectedEstateId);
  const selectedEstate = computed(() =>
    (store.state.user.landownerEstates as EstateInterface[]).find(
      (estate) => estate._id === estateId.value
    )
  );

  onMounted(() => {
    if (router.currentRoute.value.query.map) {
      viewType.value = "map";
    }

    getStages();
  });
  watch(
    () => estateId.value,
    () => {
      getStages();
    }
  );

  const loading = ref(false);

  function getStages() {
    if (estateId.value) {
      loading.value = true;
      store
        .dispatch("stage/getStages", {
          estateId: estateId.value,
          status:
            activeFilter.value.value === StatusFiltersValues.ANY
              ? ""
              : activeFilter.value.label,
        })
        .then((res) => {
          stages.value = res.data;
        })
        .finally(() => {
          loading.value = false;
        });
    }
  }

  function changeFilter(item: {
    label: StatusFiltersLabels;
    value: StatusFiltersValues;
  }) {
    activeFilter.value = item;
    getStages();
  }
  function toStage(id: string) {
    router.push({
      name: "LotsV2",
      params: { stageId: id },
    });
  }
  const copyEstateLink = () => {
    const isInteractiveMasterplan = usesInteractiveMasterplan(
      selectedEstate.value?.type
    );
    const link = `${window.location.origin}${getEstateMapPath(
      estateId.value,
      selectedEstate.value?.type
    )}`;

    copyToClipboard(
      link,
      isInteractiveMasterplan
        ? "Interactive masterplan link was copied to clipboard"
        : "Estate map link was copied to clipboard"
    );
  };

const __returned__ = { store, viewType, filters, activeFilter, stages, estateId, selectedEstate, loading, getStages, changeFilter, toStage, copyEstateLink, computed, onMounted, ref, watch, DropDown, EstateMap, get stagesStatuses() { return stagesStatuses }, get StatusFiltersLabels() { return StatusFiltersLabels }, get StatusFiltersValues() { return StatusFiltersValues }, get router() { return router }, get useStore() { return useStore }, get StageInterface() { return StageInterface }, get plural() { return plural }, get getStageStatusClass() { return getStageStatusClass }, get copyToClipboard() { return copyToClipboard }, get EstateInterface() { return EstateInterface }, get getEstateMapPath() { return getEstateMapPath }, get usesInteractiveMasterplan() { return usesInteractiveMasterplan } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})